import CryptoJS from "crypto-js"

const EncryptPassword = Password => {
  const secretKey = process.env.REACT_APP_AES_SECRET_KEY
  console.log("Secret Key", secretKey)
  const encryptedPassword = CryptoJS.AES.encrypt(Password, secretKey).toString()
  return encryptedPassword
}

const DecryptBankDetails = (encryptedData) => {
  const secretkey = process.env.REACT_APP_AES_SECRET_KEY;
  const bytes = CryptoJS.AES.decrypt(encryptedData, secretkey);
  const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  return decryptedData;
};


const EncryptPasswordUtils = { DecryptBankDetails, EncryptPassword }

export default EncryptPasswordUtils
